import {
  CitationChip,
  Table,
  TBody,
  TD,
  TH,
  THead,
  TR,
} from '@/design-system';
import { openWorkOrdersForItem } from './Strategy.transform';

export function AssetWorkOrdersDrawer({ data }: { data: { assetId?: string } }) {
  const rows = data.assetId ? openWorkOrdersForItem(data.assetId) : [];

  return (
    <div className="flex-1 space-y-4 overflow-y-auto p-5">
      <CitationChip label="[syn]" confidence="inferred" />
      <div className="overflow-x-auto">
        <Table>
          <THead>
            <TR>
              <TH>WO</TH>
              <TH>Description</TH>
              <TH>Status</TH>
              <TH>Est h</TH>
              <TH>Assigned</TH>
            </TR>
          </THead>
          <TBody>
            {rows.map((row) => (
              <TR key={row.id}>
                <TD className="font-medium text-ink-primary">{row.wo}</TD>
                <TD>{row.description}</TD>
                <TD>{row.status}</TD>
                <TD className="tabular-nums whitespace-nowrap">{row.estHours}</TD>
                <TD>{row.assigned}</TD>
              </TR>
            ))}
          </TBody>
        </Table>
      </div>
    </div>
  );
}
